import client from './client';

export const getCart = () => client.get('/api/cart');
export const addItem = (data) => client.post('/api/cart/items', data);
export const updateItem = (itemId, data) => client.patch(`/api/cart/items/${itemId}`, data);
export const removeItem = (itemId) => client.delete(`/api/cart/items/${itemId}`);
export const clearCart = () => client.post('/api/cart/clear');
export const mergeCart = () => client.post('/api/cart/merge');
